import { formatKeyboardShortcut, getKeyboardShortcutById } from '../../../lib/keyboardShortcuts';
import type { KeyboardShortcutId } from '../../../lib/keyboardShortcuts/types';

interface ShortcutHintProps {
  shortcutId: KeyboardShortcutId;
  className?: string;
}

/**
 * Renders an OS-aware shortcut label for Ant Design Menu `extra`.
 */
export default function ShortcutHint({ shortcutId, className }: ShortcutHintProps) {
  const definition = getKeyboardShortcutById(shortcutId);
  if (!definition) return null;

  const binding =
    typeof navigator !== 'undefined' && (navigator.platform || '').toLowerCase().includes('mac')
      ? definition.mac
      : definition.windows;

  return (
    <span className={className ?? 'text-gray-dark text-xs whitespace-nowrap'}>
      {formatKeyboardShortcut(binding)}
    </span>
  );
}
